module.exports = __webpack_public_path__ + "media/images/predice-7b809106e12bde99070498da55b24587.png";